import React, { useState, useEffect, useRef } from "react";
import { MdToggleOff, MdToggleOn } from "react-icons/md";
import { PiAddressBookTabs } from "react-icons/pi";
import axios from "axios";
import { useAdmin } from "../contexts/AdminContext";
import { useParams } from "react-router-dom";
import "../styles/AddUser.css";
import API_URL from "../config";

const CustomDropdown = ({ options, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div
      className="custom-dropdown"
      ref={dropdownRef}
      style={{ width: 350, margin: 0 }}
    >
      <button
        type="button"
        className="dropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "100%",
          padding: "10px",
          border: "1px solid gray",
          borderRadius: 5,
        }}
      >
        {value || "Select"}
      </button>
      {isOpen && (
        <ul className="dropdown-options">
          {options.map((option) => (
            <li key={option} onClick={() => handleOptionClick(option)}>
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const EditMembership = () => {
  const { id } = useParams();
  const { admin } = useAdmin();
  const [isToggled, setIsToggled] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const [userData, setUserData] = useState(null);
  const [membershipPackage, setMembershipPackage] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [assignedTrainer, setAssignedTrainer] = useState("");
  const [membershipStartDate, setMembershipStartDate] = useState("");
  const [renewalExpiryDate, setRenewalExpiryDate] = useState("");
  const [billingAmount, setBillingAmount] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [billingAddress, setBillingAddress] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/auth/${id}/${admin.branch}`
        );
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    const fetchTrainers = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/trainer/branch/${admin?.branch}`
        );
        setTrainers(response.data);
      } catch (error) {
        console.error("Error fetching trainers:", error);
      }
    };

    fetchUser();
    fetchTrainers();
  }, [id, admin?.branch]);

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
  };

  const handleSave = async () => {
    try {
      const payload = {
        membershipStartDate,
        renewalExpiryDate,
        package: membershipPackage,
        billingAmount,
        paymentMode,
        trainerId: assignedTrainer,
        ...(isToggled && { gstNumber, companyName, billingAddress }),
      };

      const response = await axios.patch(
        `${API_URL}/auth/${id}/${admin.branch}`,
        payload
      );
      alert("Membership details updated successfully!");
    } catch (error) {
      console.error("Error updating user:", error);
      alert("Failed to update membership details. Please try again.");
    }
  };

  return (
    <div className="addUserManagementContainer">
      <div className="addUserManagementHeader">
        <div className="addUserHeaderLeft">
          <PiAddressBookTabs
            size={30}
            color="#ff0000"
            style={{ marginRight: 10 }}
          />
          <h2>Edit Membership</h2>
        </div>
      </div>
      <div className="addUserProfileContainer">
        <h3>User Profile</h3>
        <div className="addUserProfileMain">
          <p>Basic Information :</p>
          <div className="addUserProfileInputMain">
            <div className="addUserProfileInput">
              <label>Member ID</label>
              <input type="text" value={id} readOnly />
            </div>
            <div className="addUserProfileInput">
              <label>Full Name</label>
              <input type="text" value={userData?.fullName || ""} readOnly />
            </div>
          </div>
          <div className="addUserProfileInputMain">
            <div className="addUserListInput">
              <label>Email ID</label>
              <input type="text" value={userData?.email || ""} readOnly />
            </div>
            <div className="addUserListInput">
              <label>Phone No</label>
              <input type="text" value={userData?.phoneNo || ""} readOnly />
            </div>
          </div>
        </div>
      </div>
      <div className="addUserMemberContainer">
        <h3>Membership Details:</h3>
        <div className="addUserListMain">
          <div className="addUserListInputMain">
            <div className="addUserListInput">
              <label>Membership Start Date</label>
              <input
                type="date"
                value={membershipStartDate}
                onChange={(e) => setMembershipStartDate(e.target.value)}
              />
            </div>
            <div className="addUserListInput">
              <label>Renewal/Expiry Date</label>
              <input
                type="date"
                value={renewalExpiryDate}
                onChange={(e) => setRenewalExpiryDate(e.target.value)}
              />
            </div>
          </div>
          <div className="addUserListInputMain">
            <div className="addUserProfileInput">
              <label htmlFor="package">Membership Package</label>
              <CustomDropdown
                options={[
                  "1 Month",
                  "2 Months",
                  "3 Months",
                  "6 Months",
                  "9 Months",
                  "12 Months",
                ]}
                value={membershipPackage}
                onChange={setMembershipPackage}
              />
            </div>
            <div className="addUserListInput">
              <label>Billing Amount</label>
              <input
                type="text"
                value={billingAmount}
                onChange={(e) => setBillingAmount(e.target.value)}
              />
            </div>
          </div>
          <div className="addUserListInputMain">
            <div className="addUserProfileInput">
              <label>Payment Mode</label>
              <CustomDropdown
                options={["Cash", "UPI", "Card"]}
                value={paymentMode}
                onChange={setPaymentMode}
              />
            </div>
            <div className="addUserProfileInput">
              <label>Trainer Assignment</label>
              <CustomDropdown
                options={trainers.map((trainer) => trainer.name)}
                value={assignedTrainer}
                onChange={(trainerName) => {
                  const selectedTrainer = trainers.find(
                    (trainer) => trainer.name === trainerName
                  );
                  setAssignedTrainer(selectedTrainer?.name || "");
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="addUserMemberContainer">
        <h3>GST Details Section:</h3>
        <div className="addUserListMain">
          <div className="addUserListInputMain">
            <div className="addUserListInput">
              <label>Tap to ON/OFF the Toggle.</label>
              <div
                className="toggleButton"
                style={{ cursor: "pointer", border: "none" }}
              >
                {isToggled ? (
                  <MdToggleOn color="#15ff00" onClick={handleToggle} />
                ) : (
                  <MdToggleOff color="gray" onClick={handleToggle} />
                )}
              </div>
            </div>
            {isToggled && (
              <div className="addUserListInput">
                <label>GST Number</label>
                <input
                  type="text"
                  value={gstNumber}
                  onChange={(e) => setGstNumber(e.target.value)}
                />
              </div>
            )}
          </div>
          {isToggled && (
            <div className="addUserListInputMain">
              <div className="addUserListInput">
                <label>Company/Business Name</label>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </div>
              <div className="addUserListInput">
                <label>Billing Address</label>
                <input
                  type="text"
                  value={billingAddress}
                  onChange={(e) => setBillingAddress(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="addUserBottomAggreementAndSaveButtonContainer">
        <button onClick={handleSave}>Save</button>
      </div>
    </div>
  );
};

export default EditMembership;
